import React, { useEffect, useState } from "react";
import useAuthStore from "../../store/authStore";
import { apiCall } from "../../utils/apiCall";
import { useLoader } from "../../context/LoaderContext";
import UnAuthHome from "./UnAuthHome";
import AuthHome from "./AuthHome";
import Header from "../../layout/header/Header";
import Section from "../../styled-common-components/Section";
import TrendingTopVideo from "../../components/Trending/TrendingTopVideo";
import useProfileStore from "../../store/profileStore";
import CustomSider from "../../layout/customSider/CustomSider";



const Home = () => {
  const { user, addUserInfo } = useAuthStore();
  const { showLoader, hideLoader } = useLoader();
  const { addProfileInfo } = useProfileStore();

  let home = <UnAuthHome />;

  if (user?.email) {
    home = <AuthHome />;
  }

  useEffect(() => {
    if (localStorage.getItem("authToken")) {
      showLoader();
      apiCall("/users/current")
        .then((response) => {
          if (response) {
            addUserInfo(response);
            addProfileInfo(response);
          } else {
            addUserInfo(response);
            localStorage.clear();
          }
        })
        .finally(hideLoader);
    }
  }, []);

  return (
    <>
      <CustomSider>
        <TrendingTopVideo />
        <Section>{home}</Section>
      </CustomSider>
    </>
  );
};

export default Home;
